import React from 'react';
import Navbar from '../components/navbar.tsx';

const VerifiedPage: React.FC = () => {
  return (
    <>
      <Navbar />
      The page is verified
    </>
  );
};

export default VerifiedPage;